export default {
  type: 'object',
  oneOf: [{
    properties: {
      0: {
        type: 'object',
        properties: {
          allowNotifications: {
            type: 'boolean'
          }
        },
        required: ['allowNotifications']
      }
    },
    required: ['0']
  }, {
    properties: {
      success: {
        type: 'boolean'
      },
      message: {
        type: 'string'
      }
    },
    required: ['success', 'message']
  }]
};